import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex align-center text-body-2 mt-1"
};
const _hoisted_2 = {
    key: 2,
    class: "text-error mt-2"
};
import { computed, ref, watch } from "vue";
import UploadFileComponent from "@/components/UploadFileComponent.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppealCoverSheetDialog',
    props: {
        modelValue: { type: Boolean, default: false },
        saving: { type: Boolean, default: false },
        error: { default: "" }
    },
    emits: ["update:modelValue", "save"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const blankForm = () => ({ name: "", source: "text", text: "", fileLink: "", fileName: "" });
        const form = ref(blankForm());
        watch(() => props.modelValue, (open) => {
            if (open)
                form.value = blankForm();
        });
        const canSave = computed(() => {
            const { name, source, text, fileLink } = form.value;
            if (!name.trim())
                return false;
            return source === "text" ? !!text.trim() : !!fileLink;
        });
        const onPdfUploaded = ({ link, fileName }) => {
            form.value.fileLink = link;
            form.value.fileName = fileName;
        };
        const onSave = () => {
            const { name, source, text, fileLink } = form.value;
            emit("save", source === "text" ? { name: name.trim(), text } : { name: name.trim(), fileLink });
        };
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_btn_toggle = _resolveComponent("v-btn-toggle");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": __props.modelValue,
                "max-width": "720",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = (open) => emit('update:modelValue', open))
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-subtitle-1" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode("New cover sheet template", -1)
                                    ]))]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: form.value.name,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.value.name) = $event)),
                                        label: "Template name",
                                        class: "mb-3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_btn_toggle, {
                                        modelValue: form.value.source,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.value.source) = $event)),
                                        mandatory: "",
                                        color: "primary",
                                        variant: "outlined",
                                        class: "mb-3"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, { value: "text" }, {
                                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                        _createTextVNode("Type the text", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_btn, { value: "pdf" }, {
                                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                        _createTextVNode("Upload a PDF", -1)
                                                    ]))]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    (form.value.source === 'text')
                                        ? (_openBlock(), _createBlock(_component_v_textarea, {
                                            key: 0,
                                            modelValue: form.value.text,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.value.text) = $event)),
                                            label: "Cover sheet text",
                                            rows: "8"
                                        }, null, 8, ["modelValue"]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(UploadFileComponent, {
                                                accept: ".pdf",
                                                "hide-file-name": "",
                                                onDownloadLink: onPdfUploaded
                                            }),
                                            (form.value.fileName)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                    _createVNode(_component_v_icon, {
                                                        size: "small",
                                                        class: "mr-1"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                                _createTextVNode("mdi-paperclip", -1)
                                                            ]))]),
                                                        _: 1
                                                    }),
                                                    _createTextVNode(_toDisplayString(form.value.fileName), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mt-1" }, " The PDF's text is extracted once, on save, and stored as the template. ", -1))
                                        ], 64)),
                                    (__props.error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.error), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, {
                                        variant: "text",
                                        disabled: __props.saving,
                                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('update:modelValue', false)))
                                    }, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                _createTextVNode("Cancel", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                        color: "primary",
                                        variant: "flat",
                                        rounded: "",
                                        loading: __props.saving,
                                        disabled: !canSave.value,
                                        onClick: onSave
                                    }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                _createTextVNode(" Save cover sheet ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["loading", "disabled"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
